export default __webpack_public_path__ + "static/logo-vertical-white-b164ed1c586683969f262c802de1f631.png";